//["Achinese","Adyghe","English"]

const data = {
    "Achinese": {
        "2": "ace",
        "3": "ace",
        "3066": "ace-ID",
        "c": "ID"
    },
    "Adyghe": {
        "2": "ady",
        "3": "ady",
        "3066": "ady-RU",
        "c": "RU"
    },
    "Afrikaans": {
        "2": "af",
        "3": "afr",
        "3066": "af-ZA",
        "c": "ZA"
    },
    "Ainu": {
        "2": "ain",
        "3": "ain",
        "3066": "ain-JA",
        "c": "JA"
    },
    "Akan": {
        "2": "aka",
        "3": "aka",
        "3066": "aka-GH",
        "c": "RU"
    },
    "Albanian": {
        "2": "sq",
        "3": "alb",
        "3066": "sq-AL",
        "c": "AL"
    },
    "Algerian Arabic": {
        "2": "ar",
        "3": "arq",
        "3066": "arq-DZ",
        "c": "DZ"
    },
    "Amharic": {
        "2": "am",
        "3": "amh",
        "3066": "am-ET",
        "c": "ET"
    },
    "Antigua and Barbuda Creole English": {
        "2": "aig",
        "3": "aig",
        "3066": "aig-AG",
        "c": "AG"
    },
    "Arabic": {
        "2": "ar",
        "3": "ara",
        "3066": "ar-SA",
        "c": "SA"
    },
    "Arabic SY": {
        "2": "ar_SY",
        "3": "ar_SY",
        "3066": "ar-SY",
        "c": "SY"
    },
    "Arabic TN": {
        "2": "ar_TN",
        "3": "ar_TN",
        "3066": "ar-TN",
        "c": "TN"
    },
    "Aragonese": {
        "2": "an",
        "3": "arg",
        "3066": "an-ES",
        "c": "ES"
    },
    "Armenian": {
        "2": "hy",
        "3": "arm",
        "3066": "hy-AM",
        "c": "AM"
    },
    "Arpitan Francoprovençal": {
        "2": "frp",
        "3": "frp",
        "3066": "frp-FR",
        "c": "FR"
    },
    "Assamese": {
        "2": "as",
        "3": "asm",
        "3066": "asm-IN",
        "c": "IN"
    },
    "Asturian": {
        "2": "ast",
        "3": "ast",
        "3066": "ast-ES",
        "c": "ES"
    },
    "Aymara": {
        "2": "ay",
        "3": "aym",
        "3066": "ar-BO",
        "c": "BO"
    },
    "Azerbaijani": {
        "2": "az",
        "3": "aze",
        "3066": "az-AZ",
        "c": "AZ"
    },
    "Azerbaijani IR": {
        "2": "az_IR",
        "3": "aze_IR",
        "3066": "az-IR",
        "c": "IR"
    },
    "Bahamas Creole English": {
        "2": "bah",
        "3": "bah",
        "3066": "bah-BS",
        "c": "BS"
    },
    "Bajan": {
        "2": "bjs",
        "3": "bjs",
        "3066": "bjs-BB",
        "c": "BB"
    },
    "Balkan Gipsy": {
        "2": "rm",
        "3": "rmn",
        "3066": "rm-RO",
        "c": "RO"
    },
    "Balochi": {
        "2": "bal",
        "3": "bal",
        "3066": "bal-IR",
        "c": "IR"
    },
    "Bashkir": {
        "2": "ba",
        "3": "bak",
        "3066": "ba-RU",
        "c": "RU"
    },
    "Basque": {
        "2": "eu",
        "3": "eus",
        "3066": "eu-ES",
        "c": "ES"
    },
    "Belgian French": {
        "2": "fr",
        "3": "fre",
        "3066": "fr-BE",
        "c": "BE"
    },
    "Bemba": {
        "2": "bem",
        "3": "bem",
        "3066": "bem-ZM",
        "c": "ZM"
    },
    "Bengali": {
        "2": "bn",
        "3": "ben",
        "3066": "bn-IN",
        "c": "IN"
    },
    "Berber": {
        "2": "ber",
        "3": "ber",
        "3066": "ber-MA",
        "c": "MA"
    },
    "Bhojpuri": {
        "2": "bho",
        "3": "bho",
        "3066": "ba-NP",
        "c": "NP"
    },
    "Bielarus": {
        "2": "be",
        "3": "bel",
        "3066": "be-BY",
        "c": "BY"
    },
    "Bihari": {
        "2": "bh",
        "3": "bh",
        "3066": "bh-IN",
        "c": "IN"
    },
    "Bilen": {
        "2": "byn",
        "3": "byn",
        "3066": "byn-ER",
        "c": "ER"
    },
    "Bislama": {
        "2": "bi",
        "3": "bi",
        "3066": "bi-VU",
        "c": "VU"
    },
    "Bodo": {
        "2": "brx",
        "3": "brx",
        "3066": "brx-IN",
        "c": "IN"
    },
    "Borama": {
        "2": "gax",
        "3": "gax",
        "3066": "gax-KE",
        "c": "KE"
    },
    "Bosnian": {
        "2": "bs",
        "3": "bos",
        "3066": "bs-BA",
        "c": "BA"
    },
    "Breton": {
        "2": "br",
        "3": "bre",
        "3066": "br-FR",
        "c": "FR"
    },
    "Bulgarian": {
        "2": "bg",
        "3": "bul",
        "3066": "bg-BG",
        "c": "BG"
    },
    "Burmese": {
        "2": "my",
        "3": "bur",
        "3066": "my-MM",
        "c": "MM"
    },
    "Buryat": {
        "2": "bua",
        "3": "bua",
        "3066": "bua-RU",
        "c": "RU"
    },
    "Catalan": {
        "2": "ca",
        "3": "cat",
        "3066": "ca-ES",
        "c": "ES"
    },
    "Catalan Valencia": {
        "2": "cav",
        "3": "cav",
        "3066": "cav-ES",
        "c": "ES"
    },
    "Cebuano": {
        "2": "cb",
        "3": "ceb",
        "3066": "cb-PH",
        "c": "PH"
    },
    "Central Kurdish": {
        "2": "ckb",
        "3": "ckb",
        "3066": "ckb-IR",
        "c": "IR"
    },
    "Central Nahuatl": {
        "2": "nhn",
        "3": "nhn",
        "3066": "nhn-MX",
        "c": "MX"
    },
    "Chamorro": {
        "2": "ch",
        "3": "cha",
        "3066": "cha-GU",
        "c": "GU"
    },
    "Chechen": {
        "2": "ce",
        "3": "che",
        "3066": "che-RU",
        "c": "RU"
    },
    "Cherokee": {
        "2": "chr",
        "3": "chr",
        "3066": "chr-US",
        "c": "US"
    },
    "Chhattisgarhi": {
        "2": "hne",
        "3": "hne",
        "3066": "hne-IN",
        "c": "IN"
    },
    "Chinese": {
        "2": "zh",
        "3": "chi",
        "3066": "zh-CN",
        "c": "CN"
    },
    "Chinese EN": {
        "2": "zh_en",
        "3": "zh_en",
        "3066": "zh-EN",
        "c": "EN"
    },
    "Chinese HK": {
        "2": "zh_hk",
        "3": "zh_hk",
        "3066": "zh-HK",
        "c": "HK"
    },
    "Chinese Traditional": {
        "2": "zh",
        "3": "chi",
        "3066": "zh-TW",
        "c": "TW"
    },
    "Chinese Traditional Macau": {
        "2": "zh",
        "3": "zh",
        "3066": "zh-MO",
        "c": "MO"
    },
    "Chinese Wu": {
        "2": "wuu",
        "3": "wuu",
        "3066": "wuu-CN",
        "c": "CN"
    },
    "Chinese Yue": {
        "2": "yue",
        "3": "yue",
        "3066": "yue-CN",
        "c": "CN"
    },
    "Chittagonian": {
        "2": "ctg",
        "3": "ctg",
        "3066": "ctg-BD",
        "c": "BD"
    },
    "Chukchi": {
        "2": "ckt",
        "3": "ckt",
        "3066": "ckt-RU",
        "c": "RU"
    },
    "Chuukese": {
        "2": "chk",
        "3": "chk",
        "3066": "chk-FM",
        "c": "FM"
    },
    "Chuvash": {
        "2": "cv",
        "3": "chv",
        "3066": "cv-RU",
        "c": "RU"
    },
    "Classical Greek": {
        "2": "grc",
        "3": "grc",
        "3066": "grc-GR",
        "c": "GR"
    },
    "Comorian Ngazidja": {
        "2": "zdj",
        "3": "zdj",
        "3066": "zdj-KM",
        "c": "KM"
    },
    "Coptic": {
        "2": "cop",
        "3": "cop",
        "3066": "cop-EG",
        "c": "EG"
    },
    "Cornish": {
        "2": "kw",
        "3": "cor",
        "3066": "kw-GB",
        "c": "GB"
    },
    "Corsican": {
        "2": "co",
        "3": "cos",
        "3066": "co-IT",
        "c": "IT"
    },
    "Creek": {
        "2": "mus",
        "3": "mus",
        "3066": "mus-US",
        "c": "US"
    },
    "Crimean Tatar": {
        "2": "crh",
        "3": "crh",
        "3066": "crh-RU",
        "c": "RU"
    },
    "Crioulo Upper Guinea": {
        "2": "pov",
        "3": "pov",
        "3066": "pov-GW",
        "c": "GW"
    },
    "Croatian": {
        "2": "hr",
        "3": "hrv",
        "3066": "hr-HR",
        "c": "HR"
    },
    "Czech": {
        "2": "cs",
        "3": "cze",
        "3066": "cs-CZ",
        "c": "CZ"
    },
    "Danish": {
        "2": "da",
        "3": "dan",
        "3066": "da-DK",
        "c": "DK"
    },
    "Dari": {
        "2": "fa",
        "3": "fa",
        "3066": "fa-AF",
        "c": "AF"
    },
    "Dutch": {
        "2": "nl",
        "3": "dut",
        "3066": "nl-NL",
        "c": "NL"
    },
    "Dzongkha": {
        "2": "dz",
        "3": "dzo",
        "3066": "dzo-BT",
        "c": "BT"
    },
    "Egyptian Arabic": {
        "2": "ar",
        "3": "arz",
        "3066": "ar-EG",
        "c": "EG"
    },
    "English": {
        "2": "en",
        "3": "eng",
        "3066": "en-GB",
        "c": "GB"
    },
    "English AU": {
        "2": "en",
        "3": "eng",
        "3066": "en-AU",
        "c": "AU"
    },
    "English CA": {
        "2": "en",
        "3": "eng",
        "3066": "en-CA",
        "c": "CA"
    },
    "English IE": {
        "2": "en",
        "3": "eng",
        "3066": "en-IE",
        "c": "IE"
    },
    "English IN": {
        "2": "en",
        "3": "eng",
        "3066": "en-IN",
        "c": "IN"
    },
    "English NZ": {
        "2": "en",
        "3": "eng",
        "3066": "en-NZ",
        "c": "NZ"
    },
    "English SG": {
        "2": "en",
        "3": "eng",
        "3066": "en-SG",
        "c": "SG"
    },
    "English US": {
        "2": "en",
        "3": "eng",
        "3066": "en-US",
        "c": "US"
    },
    "English ZA": {
        "2": "en",
        "3": "eng",
        "3066": "en-ZA",
        "c": "ZA"
    },
    "English old": {
        "2": "ang",
        "3": "ang",
        "3066": "ang-GB",
        "c": "GB"
    },
    "Esperanto": {
        "2": "eo",
        "3": "epo",
        "3066": "eo-EU",
        "c": "EU"
    },
    "Estonian": {
        "2": "et",
        "3": "est",
        "3066": "et-EE",
        "c": "EE"
    },
    "Ewe": {
        "2": "ee",
        "3": "ewe",
        "3066": "ee-GH",
        "c": "GH"
    },
    "Fanagalo": {
        "2": "fn",
        "3": "fng",
        "3066": "fn-FNG",
        "c": "FN"
    },
    "Faroese": {
        "2": "fo",
        "3": "fao",
        "3066": "fo-FO",
        "c": "FO"
    },
    "Farsi": {
        "2": "pes",
        "3": "pes",
        "3066": "pes-IR",
        "c": "IR"
    },
    "Fijian": {
        "2": "fj",
        "3": "fj",
        "3066": "fj-FJ",
        "c": "FJ"
    },
    "Filipino": {
        "2": "fil",
        "3": "fil",
        "3066": "fil-PH",
        "c": "PH"
    },
    "Finnish": {
        "2": "fi",
        "3": "fin",
        "3066": "fi-FI",
        "c": "FI"
    },
    "Flemish": {
        "2": "nl",
        "3": "nld",
        "3066": "nl-BE",
        "c": "BE"
    },
    "French": {
        "2": "fr",
        "3": "fre",
        "3066": "fr-FR",
        "c": "FR"
    },
    "French CH": {
        "2": "fr",
        "3": "fr",
        "3066": "fr-CH",
        "c": "CH"
    },
    "Friulian": {
        "2": "fur",
        "3": "fur",
        "3066": "fur-IT",
        "c": "IT"
    },
    "Fulah": {
        "2": "ff",
        "3": "ful",
        "3066": "ff-NG",
        "c": "NG"
    },
    "Galician": {
        "2": "gl",
        "3": "glg",
        "3066": "gl-ES",
        "c": "ES"
    },
    "Gamargu": {
        "2": "mfi",
        "3": "mfi",
        "3066": "mfi-NG",
        "c": "NG"
    },
    "Ganda": {
        "2": "lg",
        "3": "lug",
        "3066": "lg-UG",
        "c": "UG"
    },
    "Garo": {
        "2": "grt",
        "3": "grt",
        "3066": "grt-IN",
        "c": "IN"
    },
    "Georgian": {
        "2": "ka",
        "3": "geo",
        "3066": "ka-GE",
        "c": "GE"
    },
    "German": {
        "2": "de",
        "3": "ger",
        "3066": "de-DE",
        "c": "DE"
    },
    "German AT": {
        "2": "de",
        "3": "ger",
        "3066": "de-AT",
        "c": "AT"
    },
    "Glavda": {
        "2": "glw",
        "3": "glw",
        "3066": "glw-NG",
        "c": "NG"
    },
    "Greek": {
        "2": "el",
        "3": "gre",
        "3066": "el-GR",
        "c": "GR"
    },
    "Grenadian Creole English": {
        "2": "gcl",
        "3": "gcl",
        "3066": "gcl-GD",
        "c": "GD"
    },
    "Guarani": {
        "2": "gn",
        "3": "gug",
        "3066": "gn-PY",
        "c": "PY"
    },
    "Gujarati": {
        "2": "gu",
        "3": "guj",
        "3066": "gu-IN",
        "c": "IN"
    },
    "Guyanese Creole English": {
        "2": "gyn",
        "3": "gyn",
        "3066": "gyn-GY",
        "c": "GY"
    },
    "Haitian Creole French": {
        "2": "ht",
        "3": "hat",
        "3066": "ht-HT",
        "c": "HT"
    },
    "Hausa": {
        "2": "ha",
        "3": "hau",
        "3066": "ha-NE",
        "c": "NE"
    },
    "Hawaiian": {
        "2": "haw",
        "3": "haw",
        "3066": "haw-US",
        "c": "US"
    },
    "Hebrew": {
        "2": "he",
        "3": "heb",
        "3066": "he-IL",
        "c": "IL"
    },
    "Higi": {
        "2": "hig",
        "3": "hig",
        "3066": "hig-NG",
        "c": "NG"
    },
    "Hiligaynon": {
        "2": "hil",
        "3": "hil",
        "3066": "hil-PH",
        "c": "PH"
    },
    "Himachali": {
        "2": "him",
        "3": "him",
        "3066": "him-NP",
        "c": "NP"
    },
    "Hindi": {
        "2": "hi",
        "3": "hin",
        "3066": "hi-IN",
        "c": "IN"
    },
    "Hmong": {
        "2": "hmn",
        "3": "hmn",
        "3066": "hmn-CN",
        "c": "CN"
    },
    "Hungarian": {
        "2": "hu",
        "3": "hun",
        "3066": "hu-HU",
        "c": "HU"
    },
    "Hunsrik": {
        "2": "hrx",
        "3": "hrx",
        "3066": "hrx-BR",
        "c": "BR"
    },
    "Icelandic": {
        "2": "is",
        "3": "ice",
        "3066": "is-IS",
        "c": "IS"
    },
    "Ido": {
        "2": "io",
        "3": "ido",
        "3066": "io-EU",
        "c": "EU"
    },
    "Igbo": {
        "2": "ig",
        "3": "ibo",
        "3066": "ig-NG",
        "c": "NG"
    },
    "Ilokano": {
        "2": "ilo",
        "3": "ilo",
        "3066": "ilo-PH",
        "c": "PH"
    },
    "Indonesian": {
        "2": "id",
        "3": "ind",
        "3066": "id-ID",
        "c": "ID"
    },
    "Ingush": {
        "2": "inh",
        "3": "inh",
        "3066": "inh-RU",
        "c": "RU"
    },
    "Interlingua": {
        "2": "ia",
        "3": "ina",
        "3066": "ia-EU",
        "c": "EU"
    },
    "Interlingue": {
        "2": "ie",
        "3": "ile",
        "3066": "ie-EU",
        "c": "EU"
    },
    "Inuktitut": {
        "2": "iu",
        "3": "iku",
        "3066": "iu-CA",
        "c": "CA"
    },
    "Inuktitut Greenlandic": {
        "2": "kl",
        "3": "kal",
        "3066": "kal-GL",
        "c": "GL"
    },
    "Irish Gaelic": {
        "2": "ga",
        "3": "gle",
        "3066": "ga-IE",
        "c": "IE"
    },
    "Italian": {
        "2": "it",
        "3": "ita",
        "3066": "it-IT",
        "c": "IT"
    },
    "Italian CH": {
        "2": "it",
        "3": "ita",
        "3066": "it-CH",
        "c": "IT"
    },
    "Jagoi": {
        "2": "sne",
        "3": "sne",
        "3066": "sne-MY",
        "c": "MY"
    },
    "Jamaican Creole English": {
        "2": "jam",
        "3": "jam",
        "3066": "jam-JM",
        "c": "JM"
    },
    "Japanese": {
        "2": "ja",
        "3": "jpn",
        "3066": "ja-JP",
        "c": "JA"
    },
    "Javanese": {
        "2": "jv",
        "3": "jav",
        "3066": "jv-ID",
        "c": "ID"
    },
    "Kabardian": {
        "2": "kbd",
        "3": "kbd",
        "3066": "kbd-RU",
        "c": "RU"
    },
    "Kabuverdianu": {
        "2": "kea",
        "3": "kea",
        "3066": "kea-CV",
        "c": "CV"
    },
    "Kabylian": {
        "2": "kab",
        "3": "kab",
        "3066": "kab-DZ",
        "c": "DZ"
    },
    "Kalenjin": {
        "2": "kln",
        "3": "kln",
        "3066": "kln-KE",
        "c": "KE"
    },
    "Kalmyk": {
        "2": "xal",
        "3": "xal",
        "3066": "xal-RU",
        "c": "RU"
    },
    "Kamba": {
        "2": "kam",
        "3": "kam",
        "3066": "kam-KE",
        "c": "KE"
    },
    "Kannada": {
        "2": "kn",
        "3": "kan",
        "3066": "kn-IN",
        "c": "IN"
    },
    "Kanuri": {
        "2": "kr",
        "3": "kau",
        "3066": "kr-NG",
        "c": "NG"
    },
    "Kashmiri": {
        "2": "ks",
        "3": "kas",
        "3066": "ks-IN",
        "c": "IN"
    },
    "Kashubian": {
        "2": "csb",
        "3": "csb",
        "3066": "csb-PL",
        "c": "PL"
    },
    "Kazakh": {
        "2": "kk",
        "3": "kaz",
        "3066": "kk-KZ",
        "c": "KZ"
    },
    "Khmer": {
        "2": "km",
        "3": "khm",
        "3066": "km-KM",
        "c": "KM"
    },
    "Khoekhoe": {
        "2": "naq",
        "3": "naq",
        "3066": "naq-NA",
        "c": "NA"
    },
    "Kiche": {
        "2": "quc",
        "3": "quc",
        "3066": "quc-GT",
        "c": "GT"
    },
    "Kikuyu": {
        "2": "kik",
        "3": "kik",
        "3066": "kik-KE",
        "c": "KE"
    },
    "Kinyarwanda": {
        "2": "rw",
        "3": "kin",
        "3066": "rw-RW",
        "c": "RW"
    },
    "Kiribati": {
        "2": "gil",
        "3": "gil",
        "3066": "gil-KI",
        "c": "KI"
    },
    "Kirundi": {
        "2": "rn",
        "3": "run",
        "3066": "run-RN",
        "c": "RN"
    },
    "Kisii": {
        "2": "guz",
        "3": "guz",
        "3066": "guz-KE",
        "c": "KE"
    },
    "Klingon": {
        "2": "tlh",
        "3": "tlh",
        "3066": "tlh-QO",
        "c": "QO"
    },
    "Kongo": {
        "2": "kg",
        "3": "kon",
        "3066": "kg-CG",
        "c": "CG"
    },
    "Konkani": {
        "2": "kok",
        "3": "kok",
        "3066": "kok-IN",
        "c": "IN"
    },
    "Korean": {
        "2": "ko",
        "3": "kor",
        "3066": "ko-KR",
        "c": "KR"
    },
    "Kotava": {
        "2": "avk",
        "3": "avk",
        "3066": "avk-EU",
        "c": "EU"
    },
    "Kurdish": {
        "2": "ku",
        "3": "kur",
        "3066": "ku-TR",
        "c": "TR"
    },
    "Kurdish Sorani": {
        "2": "ku",
        "3": "kur",
        "3066": "ku-CKB",
        "c": "CKB"
    },
    "Kyrgyz": {
        "2": "ky",
        "3": "kir",
        "3066": "ky-KG",
        "c": "KG"
    },
    "Kölsch": {
        "2": "ksh",
        "3": "ksh",
        "3066": "ksh-DE",
        "c": "DE"
    },
    "Ladin": {
        "2": "lld",
        "3": "lld",
        "3066": "lld-IT",
        "c": "IT"
    },
    "Lao": {
        "2": "lo",
        "3": "lao",
        "3066": "lo-LA",
        "c": "LA"
    },
    "Latgalian": {
        "2": "ltg",
        "3": "ltg",
        "3066": "ltg-LV",
        "c": "LV"
    },
    "Latin": {
        "2": "la",
        "3": "lat",
        "3066": "la-VA",
        "c": "VA"
    },
    "Latvian": {
        "2": "lv",
        "3": "lav",
        "3066": "lv-LV",
        "c": "LV"
    },
    "Ligurian": {
        "2": "lij",
        "3": "lij",
        "3066": "lij-IT",
        "c": "IT"
    },
    "Limburgish": {
        "2": "li",
        "3": "lim",
        "3066": "lim-DE",
        "c": "DE"
    },
    "Lingala": {
        "2": "ln",
        "3": "lin",
        "3066": "ln-CG",
        "c": "CG"
    },
    "Literary Chinese": {
        "2": "lzh",
        "3": "lzh",
        "3066": "lzh-CN",
        "c": "CN"
    },
    "Lithuanian": {
        "2": "lt",
        "3": "lit",
        "3066": "lt-LT",
        "c": "LT"
    },
    "Lojban": {
        "2": "jbo",
        "3": "jbo",
        "3066": "jbo-EU",
        "c": "EU"
    },
    "Low German": {
        "2": "nds",
        "3": "nds",
        "3066": "nds-DE",
        "c": "DE"
    },
    "Lower Sorbian": {
        "2": "dsb",
        "3": "dsb",
        "3066": "dsb-DE",
        "c": "DE"
    },
    "Luganda": {
        "2": "lug",
        "3": "lug",
        "3066": "lug-UG",
        "c": "UG"
    },
    "Luhya": {
        "2": "luy",
        "3": "luy",
        "3066": "luy-KE",
        "c": "KE"
    },
    "Luo": {
        "2": "luo",
        "3": "luo",
        "3066": "luo-KE",
        "c": "KE"
    },
    "Luxembourgish": {
        "2": "lb",
        "3": "ltz",
        "3066": "lb-LU",
        "c": "LU"
    },
    "Maa": {
        "2": "mas",
        "3": "mas",
        "3066": "mas-KE",
        "c": "KE"
    },
    "Macedonian": {
        "2": "mk",
        "3": "mac",
        "3066": "mk-MK",
        "c": "MK"
    },
    "Maithili": {
        "2": "mai",
        "3": "mai",
        "3066": "mai-IN",
        "c": "IN"
    },
    "Malagasy": {
        "2": "mg",
        "3": "mlg",
        "3066": "mg-MG",
        "c": "MG"
    },
    "Malay": {
        "2": "ms",
        "3": "may",
        "3066": "ms-MY",
        "c": "MY"
    },
    "Malay Papuan": {
        "2": "pmy",
        "3": "pmy",
        "3066": "pmy-ID",
        "c": "ID"
    },
    "Malayalam": {
        "2": "ml",
        "3": "mal",
        "3066": "ml-IN",
        "c": "IN"
    },
    "Maldivian": {
        "2": "dv",
        "3": "div",
        "3066": "div-MV",
        "c": "MV"
    },
    "Maltese": {
        "2": "mt",
        "3": "mlt",
        "3066": "mt-MT",
        "c": "MT"
    },
    "Mandara": {
        "2": "mfi",
        "3": "mfi",
        "3066": "mfi-CM",
        "c": "CM"
    },
    "Mandarin Chinese": {
        "2": "cmn",
        "3": "cmn",
        "3066": "cmn-CN",
        "c": "CN"
    },
    "Manipuri": {
        "2": "mni",
        "3": "mni",
        "3066": "mni-IN",
        "c": "IN"
    },
    "Manx Gaelic": {
        "2": "gv",
        "3": "glv",
        "3066": "gv-IM",
        "c": "IM"
    },
    "Maori": {
        "2": "mi",
        "3": "mao",
        "3066": "mi-NZ",
        "c": "NZ"
    },
    "Mapudungun": {
        "2": "arn",
        "3": "arn",
        "3066": "arn-CL",
        "c": "CL"
    },
    "Marathi": {
        "2": "mr",
        "3": "mar",
        "3066": "mr-IN",
        "c": "IN"
    },
    "Mari": {
        "2": "mhr",
        "3": "mhr",
        "3066": "mhr-RU",
        "c": "RU"
    },
    "Marshallese": {
        "2": "mh",
        "3": "mah",
        "3066": "mh-MH",
        "c": "MH"
    },
    "Mende": {
        "2": "men",
        "3": "men",
        "3066": "men-SL",
        "c": "SL"
    },
    "Meru": {
        "2": "mer",
        "3": "mer",
        "3066": "mer-KE",
        "c": "KE"
    },
    "Mesopotamic Arabic": {
        "2": "acm",
        "3": "acm",
        "3066": "acm-IR",
        "c": "IR"
    },
    "Middle French": {
        "2": "frm",
        "3": "frm",
        "3066": "frm-FR",
        "c": "FR"
    },
    "Mijikenda": {
        "2": "nyf",
        "3": "nyf",
        "3066": "nyf-KE",
        "c": "KE"
    },
    "Mizo": {
        "2": "lus",
        "3": "lus",
        "3066": "lus-IN",
        "c": "KE"
    },
    "Mongolian": {
        "2": "mn",
        "3": "mon",
        "3066": "mn-MN",
        "c": "MN"
    },
    "Montenegrin": {
        "2": "srp",
        "3": "srp",
        "3066": "srp-ME",
        "c": "ME"
    },
    "Morisyen": {
        "2": "mfe",
        "3": "mfe",
        "3066": "mfe-MU",
        "c": "MU"
    },
    "Moroccan Arabic": {
        "2": "ar",
        "3": "ary",
        "3066": "ar-MA",
        "c": "MA"
    },
    "Mín Nan Chinese": {
        "2": "nan",
        "3": "nan",
        "3066": "nan-CN",
        "c": "CN"
    },
    "Mískito": {
        "2": "miq",
        "3": "miq",
        "3066": "ksh-NI",
        "c": "NI"
    },
    "N'Ko": {
        "2": "nqo",
        "3": "nqo",
        "3066": "nqo-CG",
        "c": "CG"
    },
    "Nahuatl": {
        "2": "nah",
        "3": "nah",
        "3066": "nah-MX",
        "c": "MX"
    },
    "Ndau": {
        "2": "ndc",
        "3": "ndc",
        "3066": "ndc-MZ",
        "c": "MZ"
    },
    "Ndebele": {
        "2": "nd",
        "3": "nde",
        "3066": "nr-ZA",
        "c": "ZA"
    },
    "Ndebele South": {
        "2": "nr",
        "3": "nbl",
        "3066": "nr-ZA",
        "c": "SA"
    },
    "Neapolitan": {
        "2": "nap",
        "3": "nap",
        "3066": "nap-IT",
        "c": "IT"
    },
    "Nepali": {
        "2": "ne",
        "3": "nep",
        "3066": "ne-NP",
        "c": "NP"
    },
    "Nepali individual": {
        "2": "npi",
        "3": "npi",
        "3066": "npi-NP",
        "c": "NP"
    },
    "Niuean": {
        "2": "niu",
        "3": "niu",
        "3066": "niu-NU",
        "c": "NU"
    },
    "Northern Sami": {
        "2": "se",
        "3": "sme",
        "3066": "se-NO",
        "c": "NO"
    },
    "Northern Sesotho": {
        "2": "nso",
        "3": "nso",
        "3066": "nso-ZA",
        "c": "ZA"
    },
    "Norwegian": {
        "2": "no",
        "3": "nor",
        "3066": "no-NO",
        "c": "NO"
    },
    "Norwegian Bokmal": {
        "2": "nb",
        "3": "nob",
        "3066": "nb-NO",
        "c": "NO"
    },
    "Norwegian Nynorsk": {
        "2": "nn",
        "3": "nno",
        "3066": "nn-NO",
        "c": "NO"
    },
    "Novial": {
        "2": "nov",
        "3": "nov",
        "3066": "nov-EU",
        "c": "EU"
    },
    "Nyanja": {
        "2": "ny",
        "3": "nya",
        "3066": "ny-MW",
        "c": "MW"
    },
    "Occitan": {
        "2": "oc",
        "3": "oci",
        "3066": "oc-FR",
        "c": "FR"
    },
    "Occitan Aran": {
        "2": "oc",
        "3": "oci",
        "3066": "oc-ES",
        "c": "ES"
    },
    "Odia": {
        "2": "ory",
        "3": "ory",
        "3066": "ory-IN",
        "c": "IN"
    },
    "Ojibwe": {
        "2": "oj",
        "3": "oji",
        "3066": "oj-CA",
        "c": "CA"
    },
    "Old Norse": {
        "2": "non",
        "3": "non",
        "3066": "non-NO",
        "c": "NO"
    },
    "Old Russian": {
        "2": "orv",
        "3": "orv",
        "3066": "orv-RU",
        "c": "RU"
    },
    "Oriya": {
        "2": "or",
        "3": "ori",
        "3066": "or-IN",
        "c": "IN"
    },
    "Oromo": {
        "2": "om",
        "3": "orm",
        "3066": "om-ET",
        "c": "ET"
    },
    "Ossetian": {
        "2": "os",
        "3": "oss",
        "3066": "os-RU",
        "c": "RU"
    },
    "Pakistani": {
        "2": "ur",
        "3": "urd",
        "3066": "ur-PK",
        "c": "PK"
    },
    "Palauan": {
        "2": "pau",
        "3": "pau",
        "3066": "pau-PW",
        "c": "PW"
    },
    "Pali": {
        "2": "pi",
        "3": "pi",
        "3066": "pi-IN",
        "c": "IN"
    },
    "Pampanga": {
        "2": "pam",
        "3": "pam",
        "3066": "pam-PH",
        "c": "PH"
    },
    "Panjabi": {
        "2": "pa",
        "3": "pan",
        "3066": "pa-IN",
        "c": "IN"
    },
    "Panjabi PK": {
        "2": "pnb",
        "3": "pnb",
        "3066": "pnb-PK",
        "c": "PK"
    },
    "Papiamentu": {
        "2": "x1",
        "3": "pap",
        "3066": "pap-CW",
        "c": "CW"
    },
    "Pashto": {
        "2": "ps",
        "3": "pst",
        "3066": "ps-PK",
        "c": "PK"
    },
    "Persian": {
        "2": "fa",
        "3": "per",
        "3066": "fa-IR",
        "c": "IR"
    },
    "Picard": {
        "2": "pcd",
        "3": "pcd",
        "3066": "pcd-FR",
        "c": "FR"
    },
    "Piemontese": {
        "2": "pms",
        "3": "pms",
        "3066": "pms-IT",
        "c": "IT"
    },
    "Pijin": {
        "2": "pis",
        "3": "pis",
        "3066": "pis-SB",
        "c": "SB"
    },
    "Polish": {
        "2": "pl",
        "3": "pol",
        "3066": "pl-PL",
        "c": "PL"
    },
    "Portuguese": {
        "2": "pt",
        "3": "por",
        "3066": "pt-PT",
        "c": "PT"
    },
    "Portuguese Brazil": {
        "2": "pt",
        "3": "por",
        "3066": "pt-BR",
        "c": "BR"
    },
    "Potawatomi": {
        "2": "pot",
        "3": "pot",
        "3066": "pot-US",
        "c": "US"
    },
    "Prussian": {
        "2": "prg",
        "3": "prg",
        "3066": "prg-PL",
        "c": "PL"
    },
    "Quebecois": {
        "2": "fr",
        "3": "fre",
        "3066": "fr-CA",
        "c": "CA"
    },
    "Quechua": {
        "2": "qu",
        "3": "que",
        "3066": "qu-PE",
        "c": "PE"
    },
    "Quenya": {
        "2": "qya",
        "3": "qya",
        "3066": "qya-EU",
        "c": "EU"
    },
    "Rohingya": {
        "2": "rhg",
        "3": "rhg",
        "3066": "rhg-MM",
        "c": "MM"
    },
    "Rohingyalish": {
        "2": "rhl",
        "3": "rhl",
        "3066": "rhl-MM",
        "c": "MM"
    },
    "Romanian": {
        "2": "ro",
        "3": "rum",
        "3066": "ro-RO",
        "c": "RO"
    },
    "Romansh": {
        "2": "roh",
        "3": "roh",
        "3066": "roh-CH",
        "c": "KE"
    },
    "Romany": {
        "2": "rom",
        "3": "rom",
        "3066": "rom-RO",
        "c": "RO"
    },
    "Russian": {
        "2": "ru",
        "3": "rus",
        "3066": "ru-RU",
        "c": "RU"
    },
    "Saint Lucian Creole French": {
        "2": "acf",
        "3": "acf",
        "3066": "acf-LC",
        "c": "LC"
    },
    "Sama": {
        "2": "sml",
        "3": "sml",
        "3066": "sml-PH",
        "c": "PH"
    },
    "Samoan": {
        "2": "sm",
        "3": "smo",
        "3066": "smo-WS",
        "c": "WS"
    },
    "Sango": {
        "2": "sg",
        "3": "sag",
        "3066": "sg-CF",
        "c": "CF"
    },
    "Sanskrit": {
        "2": "sa",
        "3": "san",
        "3066": "sa-IN",
        "c": "IN"
    },
    "Santali": {
        "2": "sat",
        "3": "sat",
        "3066": "sat-IN",
        "c": "IN"
    },
    "Sardinian": {
        "2": "sc",
        "3": "srd",
        "3066": "sc-IT",
        "c": "srd"
    },
    "Scots": {
        "2": "sco",
        "3": "sco",
        "3066": "sco-GB",
        "c": "GB"
    },
    "Scots Gaelic": {
        "2": "gd",
        "3": "gla",
        "3066": "gd-GB",
        "c": "GB"
    },
    "Sena": {
        "2": "seh",
        "3": "seh",
        "3066": "seh-ZW",
        "c": "ZW"
    },
    "Serbian": {
        "2": "sr",
        "3": "srp",
        "3066": "sr-RS",
        "c": "RS"
    },
    "Serbian ME": {
        "2": "sr",
        "3": "srp",
        "3066": "sr-ME",
        "c": "ME"
    },
    "Serbo-Croatian": {
        "2": "sh",
        "3": "scr",
        "3066": "sh-HR",
        "c": "HR"
    },
    "Seselwa Creole French": {
        "2": "crs",
        "3": "crs",
        "3066": "crs-SC",
        "c": "SC"
    },
    "Setswana": {
        "2": "tn",
        "3": "tsn",
        "3066": "tn-ZA",
        "c": "ZA"
    },
    "Shan": {
        "2": "shn",
        "3": "shn",
        "3066": "sr-MM",
        "c": "MM"
    },
    "Shona": {
        "2": "sn",
        "3": "sna",
        "3066": "sna-ZW",
        "c": "ZW"
    },
    "Shuswap": {
        "2": "shs",
        "3": "shs",
        "3066": "shs-CA",
        "c": "CA"
    },
    "Sicilian": {
        "2": "scn",
        "3": "scn",
        "3066": "scn-IT",
        "c": "IT"
    },
    "Silesian": {
        "2": "szl",
        "3": "szl",
        "3066": "szl-PL",
        "c": "PL"
    },
    "Sindarin": {
        "2": "sjn",
        "3": "sjn",
        "3066": "sjn-EU",
        "c": "EU"
    },
    "Sindhi": {
        "2": "sd",
        "3": "snd",
        "3066": "snd-IN",
        "c": "IN"
    },
    "Sinhala": {
        "2": "si",
        "3": "sin",
        "3066": "si-LK",
        "c": "LK"
    },
    "Slovak": {
        "2": "sk",
        "3": "slo",
        "3066": "sk-SK",
        "c": "SK"
    },
    "Slovenian": {
        "2": "sl",
        "3": "slv",
        "3066": "sl-SI",
        "c": "SI"
    },
    "Somali": {
        "2": "so",
        "3": "som",
        "3066": "so-SO",
        "c": "SO"
    },
    "Songhai": {
        "2": "son",
        "3": "son",
        "3066": "son-ML",
        "c": "ML"
    },
    "Sotho Southern": {
        "2": "st",
        "3": "sot",
        "3066": "nso-ZA",
        "c": "LS"
    },
    "Spanish": {
        "2": "es",
        "3": "spa",
        "3066": "es-ES",
        "c": "ES"
    },
    "Spanish AR": {
        "2": "es",
        "3": "spa",
        "3066": "es-AR",
        "c": "AR"
    },
    "Spanish America": {
        "2": "es",
        "3": "spa",
        "3066": "es-US",
        "c": "US"
    },
    "Spanish CL": {
        "2": "es",
        "3": "spa",
        "3066": "es-CL",
        "c": "CL"
    },
    "Spanish CR": {
        "2": "es",
        "3": "spa",
        "3066": "es-CR",
        "c": "CR"
    },
    "Spanish Colombian": {
        "2": "col",
        "3": "col",
        "3066": "es-CO",
        "c": "CO"
    },
    "Spanish DO": {
        "2": "es",
        "3": "spa",
        "3066": "es-DO",
        "c": "DO"
    },
    "Spanish EC": {
        "2": "es",
        "3": "spa",
        "3066": "es-EC",
        "c": "EC"
    },
    "Spanish GT": {
        "2": "es",
        "3": "spa",
        "3066": "es-GT",
        "c": "GT"
    },
    "Spanish HN": {
        "2": "es",
        "3": "spa",
        "3066": "es-HN",
        "c": "HN"
    },
    "Spanish Latam": {
        "2": "es",
        "3": "es",
        "3066": "es-419",
        "c": "419"
    },
    "Spanish Latin America": {
        "2": "es",
        "3": "spa",
        "3066": "es-MX",
        "c": "MX"
    },
    "Spanish NI": {
        "2": "es",
        "3": "spa",
        "3066": "es-NI",
        "c": "NI"
    },
    "Spanish PA": {
        "2": "es",
        "3": "spa",
        "3066": "es-PA",
        "c": "PA"
    },
    "Spanish PE": {
        "2": "es",
        "3": "spa",
        "3066": "es-PE",
        "c": "PE"
    },
    "Spanish PR": {
        "2": "es",
        "3": "spa",
        "3066": "es-PR",
        "c": "PR"
    },
    "Spanish SV": {
        "2": "es",
        "3": "spa",
        "3066": "es-SV",
        "c": "SV"
    },
    "Spanish US": {
        "2": "es",
        "3": "spa",
        "3066": "es-US",
        "c": "US"
    },
    "Spanish UY": {
        "2": "es",
        "3": "spa",
        "3066": "es-UY",
        "c": "UY"
    },
    "Spanish VE": {
        "2": "es",
        "3": "spa",
        "3066": "es-VE",
        "c": "VE"
    },
    "Sranan Tongo": {
        "2": "srn",
        "3": "srn",
        "3066": "srn-SR",
        "c": "SR"
    },
    "Standard Malay": {
        "2": "zsm",
        "3": "zsm",
        "3066": "zsm-MY",
        "c": "MY"
    },
    "Sundanese": {
        "2": "su",
        "3": "sun",
        "3066": "su-ID",
        "c": "ID"
    },
    "Swahili": {
        "2": "sw",
        "3": "swa",
        "3066": "sw-SZ",
        "c": "SZ"
    },
    "Swahili macrolanguage": {
        "2": "swh",
        "3": "swh",
        "3066": "swh-TZ",
        "c": "TZ"
    },
    "Swedish": {
        "2": "sv",
        "3": "swe",
        "3066": "sv-SE",
        "c": "SE"
    },
    "Swiss German": {
        "2": "de",
        "3": "ger",
        "3066": "de-CH",
        "c": "CH"
    },
    "Syriac Aramaic": {
        "2": "syc",
        "3": "syc",
        "3066": "syc-TR",
        "c": "TR"
    },
    "Syriac macrolanguage": {
        "2": "syr",
        "3": "syr",
        "3066": "syr-SY",
        "c": "SY"
    },
    "Tagalog": {
        "2": "tl",
        "3": "tgl",
        "3066": "tl-PH",
        "c": "PH"
    },
    "Tahitian": {
        "2": "ty",
        "3": "ty",
        "3066": "ty-PF",
        "c": "PF"
    },
    "Tai Mène": {
        "2": "tmp",
        "3": "tmp",
        "3066": "tmp-LA",
        "c": "LA"
    },
    "Tajik": {
        "2": "tg",
        "3": "tgk",
        "3066": "tg-TJ",
        "c": "TJ"
    },
    "Tamashek": {
        "2": "tmh",
        "3": "tmh",
        "3066": "tmh-DZ",
        "c": "DZ"
    },
    "Tamil": {
        "2": "ta",
        "3": "tam",
        "3066": "ta-LK",
        "c": "LK"
    },
    "Tamil India": {
        "2": "ta",
        "3": "tam",
        "3066": "ta-IN",
        "c": "IN"
    },
    "Taroko": {
        "2": "trv",
        "3": "trv",
        "3066": "zsm-TW",
        "c": "TW"
    },
    "Tatar": {
        "2": "tt",
        "3": "tat",
        "3066": "tt-RU",
        "c": "RU"
    },
    "Telugu": {
        "2": "te",
        "3": "tel",
        "3066": "te-IN",
        "c": "IN"
    },
    "Tetum": {
        "2": "tet",
        "3": "tet",
        "3066": "tet-TL",
        "c": "TL"
    },
    "Thai": {
        "2": "th",
        "3": "tha",
        "3066": "th-TH",
        "c": "TH"
    },
    "Tibetan": {
        "2": "bo",
        "3": "bod",
        "3066": "bod-CN",
        "c": "CN"
    },
    "Tigrinya": {
        "2": "ti",
        "3": "tir",
        "3066": "ti-TI",
        "c": "TI"
    },
    "Tok Pisin": {
        "2": "tpi",
        "3": "tpi",
        "3066": "tpi-PG",
        "c": "PG"
    },
    "Tokelauan": {
        "2": "tkl",
        "3": "tkl",
        "3066": "tkl-TK",
        "c": "TK"
    },
    "Toki Pona": {
        "2": "art",
        "3": "art",
        "3066": "art-EU",
        "c": "EU"
    },
    "Tongan": {
        "2": "to",
        "3": "ton",
        "3066": "ton-TO",
        "c": "TO"
    },
    "Tshiluba": {
        "2": "lua",
        "3": "lua",
        "3066": "lua-CD",
        "c": "CD"
    },
    "Tsonga": {
        "2": "ts",
        "3": "tso",
        "3066": "ts-ZA",
        "c": "ZA"
    },
    "Tswa": {
        "2": "tsc",
        "3": "tsc",
        "3066": "tsc-MZ",
        "c": "MZ"
    },
    "Tswana": {
        "2": "tn",
        "3": "tsn",
        "3066": "tn-BW",
        "c": "BW"
    },
    "Tupí": {
        "2": "tpw",
        "3": "tpw",
        "3066": "tpw-BR",
        "c": "BR"
    },
    "Turkish": {
        "2": "tr",
        "3": "tur",
        "3066": "tr-TR",
        "c": "TR"
    },
    "Turkmen": {
        "2": "tk",
        "3": "tuk",
        "3066": "tk-TM",
        "c": "TM"
    },
    "Tuvaluan": {
        "2": "tvl",
        "3": "tvl",
        "3066": "tvl-TV",
        "c": "TV"
    },
    "Udmurt": {
        "2": "udm",
        "3": "udm",
        "3066": "udm-RU",
        "c": "RU"
    },
    "Uighur": {
        "2": "ug",
        "3": "uig",
        "3066": "uig-CN",
        "c": "CN"
    },
    "Ukrainian": {
        "2": "uk",
        "3": "ukr",
        "3066": "uk-UA",
        "c": "UA"
    },
    "Uma": {
        "2": "ppk",
        "3": "ppk",
        "3066": "ppk-ID",
        "c": "ID"
    },
    "Upper Sorbian": {
        "2": "hsb",
        "3": "hsb",
        "3066": "hsb-DE",
        "c": "DE"
    },
    "Uzbek": {
        "2": "uz",
        "3": "uzb",
        "3066": "uz-UZ",
        "c": "UZ"
    },
    "Venda": {
        "2": "ve",
        "3": "ven",
        "3066": "ve-ZA",
        "c": "ZA"
    },
    "Venetian": {
        "2": "vec",
        "3": "vec",
        "3066": "vec-IT",
        "c": "IT"
    },
    "Vietnamese": {
        "2": "vi",
        "3": "vie",
        "3066": "vi-VN",
        "c": "VN"
    },
    "Vincentian Creole English": {
        "2": "svc",
        "3": "svc",
        "3066": "svc-VC",
        "c": "VC"
    },
    "Virgin Islands Creole English": {
        "2": "vic",
        "3": "vic",
        "3066": "vic-US",
        "c": "US"
    },
    "Volapük": {
        "2": "vo",
        "3": "vol",
        "3066": "vo-DE",
        "c": "DE"
    },
    "Wallisian": {
        "2": "wls",
        "3": "wls",
        "3066": "wls-WF",
        "c": "WF"
    },
    "Walloon": {
        "2": "wa",
        "3": "wln",
        "3066": "wa-BE",
        "c": "BE"
    },
    "Walser": {
        "2": "wae",
        "3": "wae",
        "3066": "wae-CH",
        "c": "CH"
    },
    "Wayuu": {
        "2": "guc",
        "3": "guc",
        "3066": "guc-CO",
        "c": "CO"
    },
    "Welsh": {
        "2": "cy",
        "3": "cym",
        "3066": "cy-GB",
        "c": "GB"
    },
    "Western Frisian": {
        "2": "fy",
        "3": "fry",
        "3066": "fy-NL",
        "c": "NL"
    },
    "Wolof": {
        "2": "wo",
        "3": "wol",
        "3066": "wo-SN",
        "c": "SN"
    },
    "Xhosa": {
        "2": "xh",
        "3": "xho",
        "3066": "xh-ZA",
        "c": "ZA"
    },
    "Yiddish": {
        "2": "yi",
        "3": "yid",
        "3066": "yi-YD",
        "c": "YDD"
    },
    "Yoruba": {
        "2": "yo",
        "3": "yor",
        "3066": "yo-NG",
        "c": "NG"
    },
    "Zaza": {
        "2": "zza",
        "3": "zza",
        "3066": "zza-TR",
        "c": "TR"
    },
    "Zulu": {
        "2": "zu",
        "3": "zul",
        "3066": "zu-ZA",
        "c": "ZU"
    }
}

export default data;